import { useCoreStore } from '@/store/coreStore'

// Título da aba. Login e /home são a casca do produto e ficam só com o sufixo;
// toda aplicação prefixa o próprio nome:
//
//   /home       ->  Markets | by QUARTIX
//   /nexus      ->  Nexus << Markets | by QUARTIX
//
// O nome sai de `contentCard` do coreStore, que já é a fonte única para o card
// da /home e para o produto selecionado - renomear um app lá (Market.Desk, por
// exemplo) muda o título junto, sem um segundo lugar para esquecer.
const SUFFIX = 'Markets | by QUARTIX'

// Rotas que são a casca, não uma aplicação.
const SHELL = new Set(['/', '/home', '/login'])

// Rotas sem card em `contentCard`: o card do /book está comentado no coreStore.
// Sem isto ela cairia no sufixo puro e pareceria a home.
const UNCARDED = {
  '/book': 'Book.Sight',
}

// Mesma regra de base que coreStore.disabledBasePaths usa: o primeiro segmento.
// Cards têm link com filho ('/flowsight/overview'), a rota atual pode ser o pai
// ou qualquer filho, e os dois precisam colidir na mesma chave.
export const baseOf = (path) => '/' + String(path || '').split('/')[1]

// Qual aplicação é dona deste path: `{ name, icon }`, ou null para a casca e
// para rota desconhecida. É a mesma pergunta que o título faz e que o véu de
// transição faz (`RouteTransitionOverlay`) - as duas respostas têm que ser a
// mesma, senão a aba diz um nome e o loading diz outro.
export function appForPath (path) {
  const base = baseOf(path)
  if (SHELL.has(base)) return null

  // Card sem link (o AutoQuote foi um) casaria com tudo em baseOf('').
  const card = useCoreStore().contentCard.find((c) => c.link && baseOf(c.link) === base)
  if (card) return { name: card.name, icon: card.icon }

  const name = UNCARDED[base]
  return name ? { name, icon: null } : null
}

export function titleForPath (path) {
  const app = appForPath(path)
  return app ? `${app.name} << ${SUFFIX}` : SUFFIX
}

export function applyPageTitle (path) {
  document.title = titleForPath(path)
}
